exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FormItem .ql-container {\n  height: auto;\n}\n.FormItem .ql-container .ql-editor {\n  height: auto;\n}\n", ""]);

// exports
